/**
 * PriceMarker builder — verbatim from v1 (research/03 §14, §15.18;
 * REQ-ELEM-4). Writes state #1–#3 as a side effect (cpc_currentPrice,
 * priceMarkerDecimals, and the STRING miniMumCartValue via toFixed) and emits
 * #alert-block/#dialog/#errDialog — a calculator without a PriceMarker has no
 * error dialogs. Preserves the malformed styles (`style=display:none;'`,
 * `'; display:inline`) and unbalanced spans.
 */
import { appState } from "../state/app-state";
import { t } from "../i18n/translate";
import { dirAttr } from "./base";
import {
  buildDialogBlock,
  buildErrorBlock,
} from "../common/common-utils";
import { formatPricing } from "../pricing";
import {
  IsNovaCurrencyCompatible,
  IsNativeCurrencyActive,
  ConvertToActive,
  FormatActive,
} from "../currency";

export function buildPriceMarker(element: any): string {
  appState.cpc_currentPrice = element.DefaultValue;
  appState.priceMarkerDecimals = element.Decimals;
  appState.miniMumCartValue = parseFloat(element.DefaultValue);
  appState.miniMumCartValue = Number(appState.miniMumCartValue).toFixed(element.Decimals);
  var borderClass =
    appState.calculatorStyling.border === "rounded" ? "rounded-edges-bottom" : "";
  var errorBlock = buildErrorBlock();
  var dialogBlock = buildDialogBlock();
  var modal = "<div id='errDialog' title='Title' style=display:none;'>" +
    "<p id='dialogMsg'> Message. </p>" +
    "</div>";
  var intialPrice = formatPricing(
    Number(appState.miniMumCartValue),
    +appState.cpc_configData.thousandSeperator,
    +appState.cpc_configData.decimalSeperator,
  );

  let isNovaCurrencyCompatible = IsNovaCurrencyCompatible();
  // Native currency v1 (#chunk3): when we will actually convert (flag on +
  // Shopify.currency present + rate !== 1), render the price ALREADY CONVERTED
  // and Intl-formatted, with NO merchant Prefix and NO <suffix> element — the
  // converted currency value owns the whole display from the very first paint.
  // Painting the converted value here (not only in the ticker step) also fixes
  // the initial-load case: UpdatePrice() only animates when finalValue differs
  // from cpc_currentPrice, so an unchanged initial price (e.g. 0) would never
  // trigger the ticker's conversion — but the marker already shows it converted.
  // The RAW numeric initial price is Number(appState.miniMumCartValue) (the same
  // value fed to formatPricing above). NO `money` class (that invites
  // third-party currency apps to rewrite a store we already convert natively).
  // When native is off — OR the shopper is in the base currency (rate === 1) —
  // we fall through to the unchanged non-Nova render, so the merchant
  // prefix/value/suffix show normally and existing goldens stay byte-identical.
  let isNativeCurrencyActive = IsNativeCurrencyActive();
  let priceTickerhtml: string;
  if (isNovaCurrencyCompatible) {
    priceTickerhtml = " <span id='priceTicker' class='money cpc-priceTicker' data-origMoney='' style='color:" +
      appState.calculatorStyling.priceTextColor +
      "'; display:inline>" + " " +
      element.Prefix + " " +
      intialPrice +
      "</span><suffix>" +
      element.Suffix +
      "</suffix></span>";
  } else if (isNativeCurrencyActive) {
    priceTickerhtml = "<span id='priceTicker' class='cpc-priceTicker' style='color:" +
      appState.calculatorStyling.priceTextColor +
      "'>" +
      FormatActive(ConvertToActive(Number(appState.miniMumCartValue))) +
      "</span></span>";
  } else {
    priceTickerhtml = element.Prefix +
      " <label id='priceTicker' style='color:" +
      appState.calculatorStyling.priceTextColor +
      "'>" +
      intialPrice +
      "</label><suffix>" +
      element.Suffix +
      "</suffix></span>";
  }
  return (
    errorBlock +
    dialogBlock +
    modal +
    "<div class='price-marker " +
    borderClass +
    "' style='background-color:" +
    appState.calculatorStyling.priceBackground +
    ";color:" +
    appState.calculatorStyling.priceTextColor +
    "'><label style='color:" +
    appState.calculatorStyling.priceTextColor +
    "'" + dirAttr(element.Name) + ">" +
    t(element.Name) +
    "</label><span id='calculator-final-value'> " +
    priceTickerhtml
    + "</div>"
  );
}
